import React from 'react';

export const ExpandedCardContext = React.createContext({
	expandedCardId: null,
	setExpandedCardId: id => {},
});
